import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './RaumResResourceBookingApp.vue';
import Step1MainBooking from './components/Step1MainBooking.vue';
import Step2DeviceBooking from './components/Step2DeviceBooking.vue';
import { store } from './store/store';

window.Apps = window.Apps || {};
Apps.initRaumResResourceBooking = function (data) {

    Vue.use(VueRouter);

    const routes = [
        { path: '/', redirect: '/main' },
        { path: '/main', component: Step1MainBooking },
        { path: '/device', component: Step2DeviceBooking }
    ];

    const router = new VueRouter({
        routes
    });

    new Vue({
        el: '#raumres-resourcebooking-app',
        data: data,
        router,
        store,
        render: h => h(App)
    });
};